import qs from 'qs';
import { get, filter, each, uniqBy } from 'lodash';
import { getUrlFriendlyAwardType } from './page-generation';

export const formatSpeed = (speed) => {
  return speed && (speed / 1000).toString();
};

export const getSigleAwardRoute = (location, year, awardType, timePeriod) => {
  const queryString = qs.stringify({
    award_type: awardType,
    time_period: timePeriod
  });

  return `/${location.replace(' ', '_').toLowerCase()}/${year}?${queryString}`;
};

// year is mandatory
export const getDatepickerOption = (year, quarterRange) => {
  if (quarterRange) {
    return `${year}/${quarterRange}`;
  }

  return year.toString();
};

/**
 * @param  {String} option
 * @return {Object} and object containing year and quarterRange
 */
export const parseDatepickerOption = (option) => {
  return {
    year: option.split('/')[0],
    quarterRange: option.split('/')[1]
  };
};

export const getLocationAwardRoute = (location, year, timePeriod) => {
  const queryString = qs.stringify({
    time_period: timePeriod
  });

  // ignore the trailing `/` at the beginning of location
  const formattedLocation = location.split('/')[1];

  if (!year) {
    return `/${formattedLocation}/?${queryString}`;
  }

  return `/${formattedLocation}/${year}/?${queryString}`;
};

export const getProviderAwardRoute = (provider, year, timePeriod) => {
  const queryString = qs.stringify({
    time_period: timePeriod
  });

  if (!year) {
    return `/${provider}/?${queryString}`;
  }

  return `/${provider}/${year}/?${queryString}`;
};

export const getAwardTypeRoute = (awardType, year, timePeriod) => {
  const queryString = qs.stringify({
    time_period: timePeriod
  });

  const urlFriendlyAwardType = getUrlFriendlyAwardType(awardType);

  if (!year) {
    return `/${urlFriendlyAwardType}/?${queryString}`;
  }

  return `/${urlFriendlyAwardType}/${year}/?${queryString}`;
};

// convert edges to datepicker options and avoid duplicates
// @param yearlyTimePeriods[array] of the format:
//  [
//    { year, edges: [ node: { timePeriod } ]},
//    ...
//  ]

// @returns an array of datepicker options.
// each option is an object with the following properties - { year, timePeriod(optional) }
export const edgesToDatepickerOptions = (yearlyTimePeriods) => {
  const results = [];

  each(yearlyTimePeriods, (yearlyTimePeriod) => {
    // add year to options array if time periods exist for it
    if (yearlyTimePeriod.edges.length > 0) {
      results.push({ year: yearlyTimePeriod.year });
    }

    // add time periods
    each(yearlyTimePeriod.edges, (edge) => {
      results.push({
        year: yearlyTimePeriod.year,
        timePeriod: get(edge, 'node.timePeriod')
      });
    });
  });

  // return results and ensure there are no duplicates
  return uniqBy(results, (result) => `${result.year}_${result.timePeriod}`);
};

export const edgesToSearchData = (edges) => {
  return (
    edges &&
    filter(edges, (edge) => {
      return get(edge, 'node.context.searchString');
    }).map((edge) => {
      return {
        type: get(edge, 'node.context.searchType'),
        name: get(edge, 'node.context.searchString'),
        route: get(edge, 'node.path')
      };
    })
  );
};
